import { useSettings } from "../../../context";
import ColorSelect from "../../../../../../../library/color-select";

const BackgroundColorConfiguration = () => {
  const { updateBackgroundSettings, getSelectedItemSettings } = useSettings();

  const currentSettings = getSelectedItemSettings();

  const handleBackgroundColorChange = (colorResult: any) => {
    updateBackgroundSettings({ color: colorResult });
  };

  const onResetBackgroundColor = () => {
    updateBackgroundSettings({ color: "transparent" });
  };

  return (
    <ColorSelect
      color={currentSettings.configuration.background.color}
      onChange={handleBackgroundColorChange}
      onReset={onResetBackgroundColor}
    />
  );
};

export default BackgroundColorConfiguration;
